import { render, staticRenderFns } from "./GatehouseAuthorization.vue?vue&type=template&id=655d7c41&scoped=true"
import script from "./GatehouseAuthorization.vue?vue&type=script&lang=js"
export * from "./GatehouseAuthorization.vue?vue&type=script&lang=js"
import style0 from "./GatehouseAuthorization.vue?vue&type=style&index=0&id=655d7c41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d7c41",
  null
  
)

export default component.exports